import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';

@Injectable()
export class PurchaseOrderService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private apiUrl = 'api/purchaseorder'; 
    private planUrl = 'api/purchasePlan'; 
    private reportUrl = 'api/poReport';
    private printUrl = 'api/print';
    private partyUrl = 'api/party'  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }
    private htmlData(res: any) {
        let body = res._body;
        return body || [];
    }
    getAuto(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/getAuto`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    qualitylist(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/qualitylist`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getPODesignReport(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.reportUrl}/getPODesignReport`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    purchaseOrderlistPrint(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.printUrl}/purchaseOrderlistPrint`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.htmlData)
            .catch(this.handleError);
    }
    getPOOrderReport(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.reportUrl}/getPOOrderReport`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getPoDetailsList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/getPoDetailsList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    typelist(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/typelist`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    polist(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/polist`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    colorlist(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/colorlist`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    styleList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/styleList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    widthlist(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/widthlist`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    
    coreGangList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/coreGangList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getDiscount(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/getDiscount`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    codelist(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/codelist`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    agentlist(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/agentlist`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    saveOrder(partyData: any): Promise<any> {
        const url = `${this.apiUrl}/save`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getOrderList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/getOrderList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getPoListCancel(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/getPoListCancel`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    onSubmitCancelPo(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/onSubmitCancelPo`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getDesignListCancel(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/getDesignListCancel`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteOrder(partyData: any): Promise<any> {
        const url = `${this.apiUrl}/delete`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getPoXlDetails(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/getPoXlDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getEditDesignList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/getEditDesignList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    CheckSeasonExist(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/CheckSeasonExist`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    

    getNonOrderedDesignList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/getNonOrderedDesignList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    onSubmitReturnAccept(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.apiUrl}/onSubmitReturnAccept`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getPurchasePlanData(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.planUrl}/getPurchasePlanData`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getPurchasePlanReportData(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.planUrl}/getPurchasePlanReportData`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    // savePurchasePlan(query: any): Promise<any[]> {
    //     let params: URLSearchParams = new URLSearchParams();
    //     for (let key in query) {
    //         params.set(key.toString(), query[key]);
    //     }

    //     let options = new RequestOptions({
    //         headers: this.headers,
    //         search: params
    //     });

    //     const url = `${this.planUrl}/savePurchasePlan`;
    //     return this.http.get(url, options)
    //         .toPromise()
    //         .then(this.extractData)
    //         .catch(this.handleError);
    // }

    savePurchasePlan(partyData: any): Promise<any> {
        const url = `${this.planUrl}/savePurchasePlan`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    getPurchasePlanDataLoaded(partyData: any): Promise<any> {
        const url = `${this.planUrl}/getPurchasePlanDataLoaded`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }


    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/purchaseorder.service.ts